import "vant/es/list/style";
import _List from "vant/es/list";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/empty.png';

const _withScopeId = n => (_pushScopeId("data-v-39a1bb22"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "empty-comment-wrap"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 抢先发表观点更易上热评哦～ ");

const _hoisted_4 = [_hoisted_2, _hoisted_3];
import composition from '@/composition';
import CommentCell from '@/components/moment/comment-cell.vue';
import { computed, watch } from 'vue';
import ua from '@/utils/platform';
export default {
  props: {
    postId: Number
  },

  setup(__props, {
    expose
  }) {
    const props = __props; // import autoHidebar from '@/components/common/auto-hide-bar.vue'

    const {
      ref,
      request,
      store
    } = composition();
    const commentList = ref([]);
    const loading = ref(false); // 加载状态

    const finished = ref(false); // 成功状态

    const error = ref(false); // 错误状态

    const page = ref(1);
    const go2233 = ref(null);

    const handle_go2233 = () => {
      if (go2233.value) {
        go2233.value.commonClick2233();
      }
    };

    const onLoad = () => {
      request.getPostComments({
        postId: props.postId,
        page: page.value,
        parentId: 0,
        order: store.state.commentOrder
      }).then(res => {
        setTimeout(() => {
          // 加载状态结束
          loading.value = false;
          page.value++;

          if (ua.isFsPlus) {
            commentList.value = commentList.value.concat(res.data);
          } else {
            commentList.value = commentList.value.concat(res.data).slice(0, 5);
          }

          if (res.data.length == 0) {
            finished.value = true;
          }
        }, 300);
      }).catch(() => {
        loading.value = false;
        error.value = true;
      });
    };

    const commentOrder = computed(() => {
      return store.state.commentOrder;
    });
    watch(commentOrder, () => {
      // 初始化
      finished.value = false;
      loading.value = true;
      error.value = false;
      page.value = 1;
      commentList.value = [];
      onLoad();
    });
    const dataListRef = ref(null);

    function reLoad() {
      // 初始化
      loading.value = false;
      finished.value = false;
      error.value = false;
      page.value = 1;
      commentList.value = [];
      dataListRef.value.check();
    }

    expose({
      reLoad
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [commentList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4)) : _createCommentVNode("", true), _createVNode(_unref(_List), {
        ref_key: "dataListRef",
        ref: dataListRef,
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        error: error.value,
        "onUpdate:error": _cache[1] || (_cache[1] = $event => error.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        "finished-text": "没有更多评论",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [!_unref(ua).isFsPlus ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "review_mask-0820",
          style: _normalizeStyle({
            'background': commentList.value.length >= 5 ? 'linear-gradient(to bottom, rgba(255,255,255,0), white)' : 'transparent'
          }),
          onClick: handle_go2233
        }, null, 4)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentList.value, (comment, index) => {
          return _openBlock(), _createBlock(CommentCell, {
            key: comment.id,
            item: comment,
            isLast: index == commentList.value.length - 1
          }, null, 8, ["item", "isLast"]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "error", "finished"])], 64);
    };
  }

};